module.exports = __webpack_public_path__ + "img/xue.ec14895c.png";